<template>
  <div class="header" @mouseleave="navMouseleave">
    <div class="content">
      <div class="left">
        <div class="logo" @click="goHome" @mouseenter="navMouseleave">
          <img src="~@/assets/image/header/logo_fc_img.png" alt="" />
        </div>
      </div>
      <div
        class="right"
        @click="upMenuBtn(!showMenu)"
        :class="{ close: showMenu }"
      >
        <div class="line"></div>
        <div class="line"></div>
        <div class="line"></div>
        <i class="el-icon-close"></i>
      </div>
      <div class="menu" v-if="showMenu">
        <ul class="left-menu1">
          <li @click="showChild(1)">
            1.专业产品<i class="el-icon-arrow-right"></i>
          </li>
          <li @click="showChild(2)">
            2.解决方案<i class="el-icon-arrow-right"></i>
          </li>
          <li @click="showChild('/blockChain')">3.区块链浏览器</li>
          <li @click="showChild('/corp')">4.关于智签</li>
        </ul>
        <ul class="left-menu2">
          <template v-if="checkNum === 1">
            <li @click="toHref('/product/existingEvidence')">
              1.1 <span>区块链存证平台</span>
            </li>
            <li @click="toHref('/product/signing')">
              1.2 <span>Xcontract区块链存证平台</span>
            </li>
            <li @click="toHref('/product/mediate')">
              1.3 <span>金融多元化解平台</span>
            </li>
            <li @click="toHref('/product/fq')">
              1.4 <span>区块链赋强公证平台</span>
            </li>
            <li @click="toHref('/home')">
              1.5 <span>LegalXChain司法联盟区块链平台</span>
            </li>
          </template>
          <template v-if="checkNum === 2">
            <li @click="toHref('/programme/blockchainPlan')">
              2.1 <span>区块链存证</span>
            </li>
            <li @click="toHref('/programme/fqPlan')">
              2.2 <span>金融赋强公证</span>
            </li>
            <li @click="toHref('/programme/litigation')">
              2.3 <span>诉调赋一体化</span>
            </li>
          </template>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: '',
  props: {},

  components: {},

  data() {
    return {
      showMenu: false,
      checkNum: 0, //默认点击的一级菜单
    };
  },

  created() {
    document.addEventListener('click', (e) => {
      console.log(this.$el.contains(e.target));
      if (!this.$el.contains(e.target)) this.showMenu = false;
    });
  },

  methods: {
    goHome() {
      this.$router.push('/home');
    },
    // 移出nav
    navMouseleave(index) {
      this.navData.forEach((ele) => (ele.isOpen = false));
      this.headerInfoShow = false;
    },
    upMenuBtn(it) {
      let flag = !!it;
      this.showMenu = !!flag;
    },
    showChild(params) {
      if (typeof params === 'number') {
        this.checkNum = params;
      } else {
        this.toHref(params);
      }
    },
    toHref(url) {
      if (this.checkHttpUrl(url)) {
        window.open(url, '_black');
      } else {
        this.$router.push(url);
      }
    },
    //判断是否为http[s]请求
    checkHttpUrl(string) {
      let givenURL;
      try {
        givenURL = new URL(string);
      } catch (error) {
        console.log('error is', error);
        return false;
      }
      return givenURL.protocol === 'http:' || givenURL.protocol === 'https:';
    },
  },
  watch: {
    $route(to, from) {
      // console.log('监听到路由发生改变');
      this.showMenu = false;
      this.checkNum = 0;
    },
  },
};
</script>

<style scoped lang="scss">
.header {
  position: fixed;
  top: 0;
  z-index: 9999;
  width: 100%;
  height: 4rem;
  background-color: #fff;

  .content {
    display: flex;
    justify-content: space-between;
    position: relative;
  }

  .logo {
    width: 100%;
  }

  img {
    width: 10rem;
    height: 4rem;
    margin-left: 20px;
  }

  .right {
    width: 4rem;
    height: 4rem;
    background-color: #b41c2e;
    padding: 0.8rem 0.55rem;
    cursor: pointer;

    .line {
      margin: 0 auto;
      width: 2rem;
      height: 2px;
      background-color: #fff;
      margin-bottom: 8px;

      &:last-child {
        margin-bottom: 0;
      }
    }

    .el-icon-close {
      display: none;
    }

    &.close {
      display: flex;
      align-items: center;
      justify-content: center;

      .el-icon-close {
        display: block;
        color: #fff;
        font-size: 3rem;
      }

      .line {
        display: none;
      }
    }
  }

  .menu {
    position: absolute;
    top: 4rem;
    width: 100vw;
    display: flex;
    box-shadow: 0px 0.2rem 0.2rem #fff;
    background-color: #fff;
    .left-menu1 {
      padding: 2.4rem 1rem 2.4rem 1.6rem;
      background: #ededed;
      li {
        font-size: 1.4rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #000000;
        line-height: 2rem;
        margin-top: 1.2rem;
        position: relative;
        i {
          position: absolute;
          right: 0;
          top: 0.3rem;
        }
      }
    }

    .left-menu2 {
      flex: 1;
      display: flex;
      flex-direction: column;
      padding: 2rem 0 2rem 1rem;
      background-color: #f7f7f7;

      li {
        font-size: 1.2rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #37393b;
        line-height: 1.7rem;
        margin: 0.6rem 0;
      }
    }
  }
}
</style>
